module.exports = __webpack_public_path__ + "static/img/hzs.3b208b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/vipnotifyProject/images/hzs.jpg
// module id = U6LU
// module chunks = 5